module.exports = __webpack_public_path__ + "img/credit-dial.33519464.svg";